import React from 'react';
import {
  Tooltip,
  TableCell,
  TableRow,
  TextField,
  IconButton
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

// Utils.
import { formatDateUS, getMonthName } from '../../../../helpers/utils';

// Components.
import { CurrencyFormatter } from '../../shared/Formatters';

const AumAggregationRow = ({
  pwgAumAggregation,
  handleChangeAumAggregation,
  handleBlurAumAggregation,
  handleRemoveAumAggregation,
}) => {
  const handleChange = (field, value) => handleChangeAumAggregation(pwgAumAggregation, field, value);

  const handleBlur = (field) => handleBlurAumAggregation(pwgAumAggregation, field);

  return (
    <TableRow hover key={pwgAumAggregation.id}>
      <TableCell>{pwgAumAggregation.month ? getMonthName(pwgAumAggregation.month) : ''}</TableCell>
      <TableCell>{pwgAumAggregation.year}</TableCell>
      <TableCell>
        <TextField
          label='AUM'
          variant='outlined'
          name='total_aum'
          value={pwgAumAggregation.total_aum ?? ''}
          onBlur={() => handleBlur('total_aum')}
          onChange={(e) => handleChange('total_aum', e.target.value)}
          InputLabelProps={{ shrink: pwgAumAggregation.total_aum != null }}
          InputProps={{ inputComponent: CurrencyFormatter }}
        />
      </TableCell>
      <TableCell>
        <TextField
          label='Minimum Account Size'
          variant='outlined'
          name='minimum_account_size'
          value={pwgAumAggregation.minimum_account_size ?? ''}
          onBlur={() => handleBlur('minimum_account_size')}
          onChange={(e) => handleChange('minimum_account_size', e.target.value)}
          InputLabelProps={{ shrink: pwgAumAggregation.minimum_account_size != null }}
          InputProps={{ inputComponent: CurrencyFormatter }}
        />
      </TableCell>
      <TableCell>{formatDateUS(pwgAumAggregation.created_at)}</TableCell>
      <TableCell>{pwgAumAggregation.automatic ? 'Automatic' : 'Manual'}</TableCell>
      <TableCell>
        <TextField
          label='Source'
          variant='outlined'
          name='source'
          value={pwgAumAggregation.source ?? ''}
          onBlur={() => handleBlur('source')}
          onChange={(e) => handleChange('source', e.target.value)}
        />
      </TableCell>
      <TableCell>
        <Tooltip title={'Delete'}>
          <IconButton
            edge='end'
            aria-label='delete'
            onClick={() => handleRemoveAumAggregation(pwgAumAggregation.id)}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default AumAggregationRow;
